import styled from "styled-components";

import { Typography } from "styled/Typography";
import { theme } from "theme";

export const LinkTitle = styled(Typography.Title)`
  color: ${theme.color.text.tertiary};
`;
